import { Controller } from "@hotwired/stimulus"
import { triggerHaptic } from "../src/trigger_native_haptic"

// The greeting stays usable when a retained native tab has an older JS bundle.
// Only hide it after this controller connects and can schedule its reveal.
export default class extends Controller {
  static targets = ["checking", "result"]
  static values = { settleDelay: { type: Number, default: 1800 } }

  connect() {
    if (document.documentElement.hasAttribute("data-turbo-preview")) return
    if (this.prefersReducedMotion) return

    this.revealTimer = setTimeout(() => this.reveal(), this.settleDelayValue)
    this.resultTarget.style.visibility = "hidden"
    this.resultTarget.setAttribute("aria-hidden", "true")
    this.resultTarget.setAttribute("inert", "")
    this.checkingTarget.hidden = false
  }

  disconnect() {
    clearTimeout(this.revealTimer)
    this.animation?.cancel()
    this.finishReveal()
  }

  reveal() {
    // Reveal synchronously: animation support must never gate the content.
    this.finishReveal()

    if (!this.prefersReducedMotion && this.resultTarget.animate) {
      this.animation = this.resultTarget.animate(
        [{ opacity: 0 }, { opacity: 1 }],
        { duration: 200, easing: "ease-out" }
      )
    }

    this.dispatch("revealed")
    triggerHaptic()
  }

  finishReveal() {
    if (this.hasCheckingTarget) this.checkingTarget.hidden = true
    if (this.hasResultTarget) {
      this.resultTarget.style.removeProperty("visibility")
      this.resultTarget.removeAttribute("aria-hidden")
      this.resultTarget.removeAttribute("inert")
    }
  }

  get prefersReducedMotion() {
    return window.matchMedia?.("(prefers-reduced-motion: reduce)").matches === true
  }
}
